import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router-dom';

interface MstRegistrationFooterButtonGroupProps {
  onRegister: () => void;
  onReset: () => void;
  onToMaintenance?: () => void;
}

export function MstRegistrationFooterButtonGroup({
  onRegister,
  onReset,
  onToMaintenance,
}: MstRegistrationFooterButtonGroupProps) {
  const navigate = useNavigate();
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('register')} onClick={onRegister} />
      <Button label={getButtonName('reset')} onClick={onReset} />
      <Button label={getButtonName('toMaintenance')} onClick={onToMaintenance ?? (() => navigate('../'))} />
    </ButtonGroup>
  );
}
